export default "__VITE_ASSET__ttYO_vCk__"